module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list', {
    staticClass: "pt-0",
    attrs: {
      "dense": ""
    }
  }, [_c('v-divider', {
    attrs: {
      "light": ""
    }
  }), _vm._v(" "), _vm._l((_vm.channels), function(channel) {
    return _c('v-list-tile', {
      key: channel.id,
      class: {
        'is_active': _vm.setChannelActive(channel)
      },
      on: {
        "click": function($event) {
          _vm.changeChannel(channel)
        }
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("# " + _vm._s(channel.name)), (_vm.getNotification(channel) > 0 && channel.id !== _vm.currentChannel.id) ? _c('div', {
      staticClass: "ui label purple channel__count"
    }, [_vm._v(_vm._s(_vm.getNotification(channel)))]) : _vm._e()])], 1)], 1)
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0996b46e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sidebar/Channels.vue
// module id = 218
// module chunks = 1